export default [
    { 
        innerText: "+",
        id: "add",
        which: 187
    },
    { 
        innerText: "-",
        id: "subtract",
        which: 189
    },{ 
        innerText: "x",
        id: "multiply",
        which: 88
    },
    { 
        innerText: "/",
        id: "divide",
        which: 191
    },
    { 
        innerText: "7",
        id: "seven",
        which: 55
    },
    { 
        innerText: "8",
        id: "eight",
        which: 56
    },
    { 
        innerText: "9",
        id: "nine",
        which: 57
    },
    { 
        innerText: "C",
        id: "clear",
        which: 67
    },
    {
        innerText: "4",
        id: "four",
        which: 52
    },
    {
        innerText: "5",
        id: "five",
        which: 53
    },
    { 
        innerText: "6",
        id: "six",
        which: 54
    },
    { 
        innerText: ".",
        id: "decimal",
        which: 190
    },
    {
        innerText: "1",
        id: "one",
        which: 49
    },    {
        innerText: "2",
        id: "two",
        which: 50
    },
    {
        innerText: "3",
        id: "three",
        which: 51
    },{ 
        innerText: "bcksp",
        id: "bcksp",
        which: 8
    },{ 
        innerText: "0",
        id: "zero",
        which: 48
    },
    { 
        innerText: "=",
        id: "equals",
        which: 13
    }
];
